import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Unsubscribe = lazy(() => import("@/pages/Unsubscribe"));

export const Route = createFileRoute("/_public/unsubscribe")({
  component: Unsubscribe,
});
